import { mediaData } from '@/mocks/home';

export default function SectionMedia() {
  return (
    <section
      id="media"
      className="py-16 md:py-20 bg-background-100"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-accent-400 bg-accent-500/10 px-3 py-1 rounded-full mb-3">
            先睹为快
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            精彩预告
          </h2>
          <p className="text-sm text-foreground-400 mt-2">热门影视预告片一览</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-200/70 rounded-xl overflow-hidden border border-background-300/40 hover:border-accent-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-50/40 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-950 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-background-50/85 backdrop-blur-sm rounded-full px-2.5 py-1 text-[11px] font-medium text-foreground-200">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 mt-1.5 text-[11px] text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}